// extracted by mini-css-extract-plugin
module.exports = {"section":"_2fiK3","list":"hOOD0","listItem":"_3TeVL","link":"_2iUfj","active":"_3B2x_"};